import { render, staticRenderFns } from "./ReturnReason.vue?vue&type=template&id=f0b0559c&scoped=true"
import script from "./ReturnReason.vue?vue&type=script&lang=js"
export * from "./ReturnReason.vue?vue&type=script&lang=js"
import style0 from "./ReturnReason.vue?vue&type=style&index=0&id=f0b0559c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b0559c",
  null
  
)

export default component.exports